import { gql, useQuery } from "@apollo/client";
import { getFetchPolicyOptions } from "api/utils";
import { SecuritiesQuery } from "../types";

interface LoadFormQuery {
  loadForm: {
    id: number;
    lastModifiedBy: string;
    lastModifiedDate: string;
    formName: string;
    formDefinition: string;
  };
}

export const LOAD_FORM_QUERY = gql`
  query LoadForm($formId: Long) {
    loadForm(id: $formId) {
      id
      lastModifiedBy
      lastModifiedDate
      formName
      formDefinition
    }
  }
`;

export const useLoadForm = (formId: number) => {
  const { loading, error, data, refetch } = useQuery<LoadFormQuery>(
    LOAD_FORM_QUERY,
    {
      variables: { formId },
      ...getFetchPolicyOptions(`useLoadForm.${formId}`),
    }
  );

  return {
    loading: loading,
    error: error,
    data: data && data,
    refetch,
  };
};
